export default class FooterMenu {
    static fromPartial(partial) {
        var _a, _b, _c, _d;
        const section = new FooterMenu();
        const translation = (_a = partial.translations) === null || _a === void 0 ? void 0 : _a.pop();
        section.name = (_b = translation === null || translation === void 0 ? void 0 : translation.name) !== null && _b !== void 0 ? _b : '';
        section.link = (_c = translation === null || translation === void 0 ? void 0 : translation.link) !== null && _c !== void 0 ? _c : '';
        section.sort = (_d = partial.sort) !== null && _d !== void 0 ? _d : 0;
        return section;
    }
}
